import { createStandardAction } from 'typesafe-actions';
export var socketSetupSuccess = createStandardAction('@socket/SOCKET_SETUP_SUCCESS')();
export var socketReconnect = createStandardAction('@socket/SOCKET_RECONNECT')();
// This action is coming from traffic control
export var receiveSocketConnection = createStandardAction('RECEIVE_SOCKET_CONNECTION')();